module.exports = "<div class=\"m-measureihm-tooltip measureihm\"></div>";